import './alert.js'
import './animated.js'
import './bg.js'
import './paragraph--faq.js'
import './swiper-leaderboard.js'
import './swiper-galerie-text.js'
import './swiper-recettes.js'
import './paragraph--galerie.js'
import './header.js'
import './lang.js'
import './modal.js'
import './more-link.js'
import './smooth-scroll.js'
